<template>
  <auth-template>
    <b-col md="12" sm="12">
      <b-card no-body class="mx-4">
        <b-card-body class="p-4">
          <b-col md="12" sm="12">
            <b-row>
              <b-col md="12" sm="12">
                <img src="/static/img/logo.png" style="width: 20%;  "/>
              </b-col>
            </b-row>
          </b-col>
          <b-row>
            <b-col md="12" sm="12">
              <h1>Ficha de inscrição</h1>
            </b-col>
          </b-row>
          <b-form v-on:submit.prevent="onSubmit">
            <p class="text-muted">
              Caro/Cara participante da XI Conferência Nacional dos Direitos das Crianças e dos Adolescentes – CNDCA, sejam todos muito bem-vindos!
            </p>
            <p class="text-muted">
              Este é o nosso primeiro contato com você no âmbito da XI CNDCA, que nesta edição acontecerá totalmente online. É por aqui que vamos conhecer você. Por meio deste contato buscaremos entender as suas necessidades e as suas experiências, enquanto mobilizador/a social, o que irá nos ajudar a construir a primeira Conferência online do Brasil. E para que ela atenda as suas expectativas de futuro na promoção e defesa dos direitos das crianças e dos adolescentes, precisamos que preencha os dados solicitados nesta Ficha do Participante.
            </p>
            <p class="text-muted">
              Aqui você também vai poder confirmar qual eixo de discussão do seu interesse, para que assim possa interagir com mais efetividade.
              O primeiro passo é gerarmos o seu login e senha de acesso. Para tanto você precisará informar seu nome e e-mail, por meio do qual receberá um link para criação de senha de acesso ao formulário de inscrição.  É com essa senha que você poderá acessar o ambiente virtual da XI CNDCA, as lives das plenárias e aos eixos de discussão, será necessário a sua confirmação. Guarde suas informações de login e senha até o final da Conferência, pois elas serão necessárias para seu acesso ao ambiente virtual da XI CNDCA e para a impressão do seu certificado de participação.
              Todos os campos da ficha devem ser respondidos. Em caso de dúvidas, por favor, nos contate pelo e-mail: se.conanda@mdh.gov.br e ou pelo fone (61) 2027-3344
            </p>

            <b-card>
              <h2>Dados básicos de cadastro</h2>
              <hr>
              <b-row>
                <b-col cols="12">
                  <b-form-group label="Nome:">
                    <b-input-group class="mb-3">
                      <b-input-group-prepend>
                        <b-input-group-text><i class="icon-user"></i></b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input type="text"
                                    class="form-control"
                                    placeholder="Nome completo:"
                                    autocomplete="nome"
                                    v-model.trim="form.nome"
                                    disabled />
                      <b-form-invalid-feedback id="input1LiveFeedback3">Nome é obrigatório.</b-form-invalid-feedback>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12">
                  <b-form-group label="Nome social:">
                    <b-input-group class="mb-3">
                      <b-input-group-prepend>
                        <b-input-group-text><i class="icon-user"></i></b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input type="text"
                                    class="form-control"
                                    placeholder="Informe o nome social caso possua:"
                                    autocomplete="nome"
                                    v-model.trim="form.nome_social"
                                    disabled />
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12">
                  <b-form-group label="E-mail:">
                    <b-input-group class="mb-3">
                      <b-input-group-prepend>
                        <b-input-group-text>@</b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input type="text"
                                    class="form-control"
                                    placeholder="E-mail"
                                    autocomplete="email"
                                    v-model.trim="form.email"
                                    disabled />
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>
              <h2>Ficha do/a Participante da XI CNDCA</h2>
              <hr>
              <b-row>
                <!--<b-col cols="12">
                  <b-form-group>
                    <b-form-group label="Precisamos saber como se dará sua participação na XI CNDCA. Se desejar , insira aqui a sua foto.">
                      XXXUPLOADXXXX
                    </b-form-group>
                  </b-form-group>
                </b-col> -->
              </b-row>
              <b-row>
                <b-col cols="12">
                    <strong>Consentimento de comunicação: </strong>Autorizo o tratamento dos dados pessoais fornecidos para envio de e-mails e análises de segmentação e perfil de públicos.<br>
                    <strong>Autorização de uso de imagem: </strong>Autorizo o uso de meu nome, minha imagem, estando ciente de que a transmissão/live poderá ser disponibilizada em quaisquer outros meios, inclusive sendo disponibilizada para  acesso público.<br>
                    Caso não queira utilizar vídeo e/ou som durante os trabalhos da Conferência, suas perguntas, comentários e sugestões poderão ser realizados de modo escrito, por chat.<br><br>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12">
                  <b-form-checkbox
                          v-model="form.termos"
                          :options="options"
                          name="checkbox-validation" disabled >Autorizo o tratamento dos dados pessoais fornecidos para envio de e-mails e análises de segmentação e perfil de públicos.
                  </b-form-checkbox>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12">
                  <b-form-checkbox
                          v-model="form.receber_copia"
                          :options="options"
                          name="checkbox-validation" disabled>Caso queira receber uma cópia dessa pesquisa no seu e-mail sinalize aqui.
                  </b-form-checkbox>
                </b-col>
              </b-row>
              <br><br>
              <b-row>
                <b-col md="8" sm="12">
                  <b-form-group label="1. Na Conferência, você é?:">
                       <b-form-select v-model.trim="form.participacao"  placeholder="" class="mb-3" :options='form_options.options_participacao' disabled>
                      </b-form-select>
                  </b-form-group>
                </b-col>
                <b-col md="4" sm="12" v-if="form.participacao === 'D'">
                  <b-form-group label="1.1 Então você é?:">
                       <b-form-select v-model.trim="form.tipo_delegado" placeholder="" class="mb-3" :options='form_options.options_tipo_delegado' disabled>
                      </b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="6" sm="12" v-if="form.participacao !== 'A'">
                  <b-form-group label="2. Na representação de seu estado, você é chefe de delegação?">
                       <b-form-select v-model.trim="form.chefe_delegacao" placeholder="" class="mb-3" :options='options_sim_nao' disabled>
                      </b-form-select>
                  </b-form-group>
                </b-col>
                <b-col md="6" sm="12" v-if="form.participacao !== 'A'">
                  <b-form-group label="3. Qual é o perfil de sua representação?" >
                       <b-form-select v-model.trim="form.perfil_representacao" placeholder="" class="mb-3" :options='form_options.options_perfil_representacao' disabled>
                      </b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" v-if="form.participacao !== 'A'">
                  <b-form-group label="4. Qual é a natureza de sua representação na XI CNDCA?">
                       <b-form-select v-model.trim="form.natureza_representacao" placeholder="" class="mb-3" :options='form_options.options_natureza_representacao' disabled>
                      </b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row v-if="form.natureza_representacao === 'P' && form.participacao !== 'A'">
                <b-col cols="12">
                  <b-form-group label="4.1 Que órgão você representa?">
                    <b-input-group class="mb-3">
                      <b-form-input type="text"
                                    class="form-control"
                                    placeholder="Nome do órgão"
                                    v-model.trim="form.orgao_representacao"
                                    disabled />
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12">
                  <b-form-group label="4.2 Qual segmento você representa?">
                      <b-form-select v-model.trim="form.segmento_representacao" disabled placeholder="" class="mb-3" :options='form_options.options_segmento_representacao'>
                      </b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row v-if="form.natureza_representacao === 'S' && form.participacao !== 'A'">
                <b-col cols="12">
                  <b-form-group label="4.3 A qual instituição/órgão você está vinculado?">
                    <b-input-group class="mb-3">
                      <b-form-input type="text"
                                    class="form-control"
                                    placeholder="Nome do órgão/instituição"
                                    v-model.trim="form.orgao_instituicao_vinculado"
                                    disabled />
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row v-if="form.natureza_representacao === 'S' && form.participacao !== 'A'">
                <b-col md="6" sm="12">
                  <b-form-group label="4.4 Em qual estado está localizada a instituição/órgão a que você está vinculado/a?" >
                    <multiselect
                      v-model="form.estado_orgao_instituicao"
                      :options="estados"
                      label="sigla"
                      track-by="id"
                      placeholder="Selecione"
                      selectLabel="" deselectLabel="" selectedLabel=""
                      :tagglabe="true"
                      :multiple="true"
                      :max="1"
                      disabled >
                        <span slot="maxElements"></span>
                        <span slot="noResult">Nenhum encontrado</span>
                        <span slot="noOptions">Lista vazia</span>
                      </multiselect>
                  </b-form-group>
                </b-col>

                <b-col md="6" sm="12">
                  <b-form-group label="4.4.1 Em qual cidade está localizada a instituição/órgão a que você está vinculado/a?">
                    <multiselect
                      v-model="form.cidade_orgao_instituicao"
                      :options="cidades_orgao_instituicao"
                      label="cidade"
                      track-by="id"
                      placeholder="Selecione"
                      return="id"
                      :multiple="true"
                      :max="1"
                      disabled >
                      </multiselect>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row v-if="form.natureza_representacao === 'P' && form.participacao !== 'A'">
                <b-col cols="12">
                  <b-form-group label="4.5 Qual o telefone da instituição/órgão a que você está vinculado?">
                    <b-input-group class="mb-3">
                      <b-form-input v-mask="'(###) #####.####'"
                                    type="text"
                                    class="form-control"
                                    placeholder="Informe o telefone da instituição/órgão"
                                    v-model.trim="form.telefone_orgao_instituicao"
                                    disabled/>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row v-if="form.participacao !== 'A'">
                <b-col cols="12">
                  <b-form-group label="5. Em qual Eixo Temático você atuará na Conferência?">
                       <b-form-select disabled v-model.trim="form.eixo_tematico"  placeholder="" class="mb-3" :options='form_options.options_eixo_tematico'>
                      </b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>

              <h2>Dados Pessoais</h2>
              <hr>
              <p class="text-muted">
                Bom, já sabemos seu nome e de que forma participará da Conferência, mas precisamos que complete a ficha com os seus dados pessoais.
              </p>

              <b-row>
                <b-col cols="12">
                  <b-form-group label="6. Qual sua nacionalidade?">
                    <b-form-select disabled v-model.trim="form.nacionalidade" placeholder="" class="mb-3" :options='form_options.options_nacionalidade'>
                    </b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row v-if="form.nacionalidade == 'B' || form.nacionalidade == 'N'">
                <b-col cols="12">
                  <b-form-group label="7. CPF:">
                    <b-input-group class="mb-3">
                      <b-form-input v-mask="'###.###.###-##'"
                                    type="text"
                                    class="form-control"
                                    placeholder="CPF"
                                    v-model="form.cpf"
                                    disabled
                                    />
                      <b-form-invalid-feedback id="inputLiveFeedback3">CPF é obrigatório.</b-form-invalid-feedback>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row v-if="form.nacionalidade == 'E'">
                <b-col cols="12">
                  <b-form-group label="7. Passaporte:">
                    <b-input-group class="mb-3">
                      <b-form-input type="text"
                                    class="form-control"
                                    placeholder="Passaporte"
                                    v-model="form.passaporte"
                                    disabled
                                    />
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row v-if="form.nacionalidade == 'B' || form.nacionalidade == 'N'">
                <b-col cols="12">
                  <b-form-group label="8. Número do Registro Geral (RG):">
                    <b-input-group class="mb-3">
                      <b-form-input v-mask='"##########"'
                                    type="text"
                                    class="form-control"
                                    placeholder="Número do Registro Geral (RG)"
                                    v-model="form.rg"
                                    disabled
                                    />
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row v-if="form.nacionalidade">
                <b-col cols="12">
                  <b-form-group label="9. Órgão Emissor">
                    <b-input-group class="mb-3">
                      <b-form-input type="text"
                                    class="form-control"
                                    placeholder="Órgão Emissor"
                                    v-model="form.orgao_emissor"
                                    disabled
                                    />
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col cols="12">
                  <b-form-group label="10. Data de Nascimento">
                    <b-input-group class="mb-3">
                      <b-form-input v-mask="'##/##/####'"
                                    type="text"
                                    class="form-control"
                                    placeholder="Data de Nascimento"
                                    v-model="form.data_nascimento"
                                    disabled
                                    />
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row v-if="form.nacionalidade == 'B' || form.nacionalidade == 'N'">
                <b-col md="6" sm="12">
                  <b-form-group label="11. Estado em que nasceu">
                    <multiselect
                      v-model="form.estado_origem"
                      :options="estados"
                      label="sigla"
                      track-by="id"
                      placeholder="Selecione"
                      selectLabel="" deselectLabel="" selectedLabel=""
                      :tagglabe="true"
                      :multiple="true"
                      :max="1"
                      disabled>
                        <span slot="maxElements"></span>
                        <span slot="noResult">Nenhum encontrado</span>
                        <span slot="noOptions">Lista vazia</span>
                      </multiselect>
                  </b-form-group>
                </b-col>

                <b-col md="6" sm="12">
                  <b-form-group label="12. Cidade onde nasceu" >
                    <multiselect
                      v-model="form.cidade_origem"
                      :options="cidades_origem"
                      label="cidade"
                      track-by="id"
                      placeholder="Selecione"
                      return="id"
                      :multiple="true"
                      :max="1"
                      disabled>
                      </multiselect>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="6" sm="12">
                  <b-form-group label="13. Estado em que mora atualmente">
                    <multiselect
                      v-model="form.estado_moradia"
                      :options="estados"
                      label="sigla"
                      track-by="id"
                      placeholder="Selecione"
                      selectLabel="" deselectLabel="" selectedLabel=""
                      :tagglabe="true"
                      :multiple="true"
                      :max="1"
                      disabled>
                        <span slot="maxElements"></span>
                        <span slot="noResult">Nenhum encontrado</span>
                        <span slot="noOptions">Lista vazia</span>
                      </multiselect>
                  </b-form-group>
                </b-col>

                <b-col md="6" sm="12">
                  <b-form-group label="14. Cidade onde mora atualmente" >
                    <multiselect
                      v-model="form.cidade_moradia"
                      :options="cidades_moradia"
                      label="cidade"
                      track-by="id"
                      placeholder="Selecione"
                      return="id"
                      :multiple="true"
                      :max="1"
                      disabled>
                      </multiselect>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col cols="12">
                  <b-form-group label="15. Telefone celular (WhatsApp e SMS)">
                    <b-row>
                      <b-col cols="4">
                        <b-input-group class="mb-3">
                          <b-form-input v-mask="'###'"
                                        type="text"
                                        class="form-control"
                                        placeholder="DDD"
                                        v-model="form.telefone_celular_ddd"
                                        disabled
                                        />
                        </b-input-group>
                      </b-col>
                      <b-col cols="8">
                        <b-input-group class="mb-3">
                          <b-form-input v-mask="'#####-####'"
                                        type="text"
                                        class="form-control"
                                        placeholder="Número"
                                        v-model="form.telefone_celular_numero"
                                        disabled
                                        />
                        </b-input-group>
                      </b-col>
                    </b-row>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col cols="12">
                  <b-form-group label="16. Qual gênero você se identifica?">
                    <b-form-select v-model.trim="form.genero" placeholder="" class="mb-3" :options='form_options.options_genero' disabled>
                    </b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col cols="12">
                  <b-form-group label="17. Quanto sua orientação sexual?">
                    <b-form-select v-model.trim="form.orientacao_sexual" class="mb-3" :options='form_options.options_orientacao_sexual' disabled>
                    </b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col cols="12">
                  <b-form-group label="18. Você gostaria de informar sua identidade gênero?">
                    <b-form-select v-model.trim="form.identidade_genero" class="mb-3" :options='form_options.options_identidade_genero' disabled>
                    </b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col cols="12">
                  <b-form-group label="19. Raça/Etnia"  invalid-feedback='A raça/etnia é obrigatório.'>
                    <b-form-select v-model.trim="form.raca_etnia" class="mb-3" :options='form_options.options_raca_etnia' disabled>
                    </b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col cols="12">
                  <b-form-group label="20. Se você é representante de Povos e comunidades tradicionais indique qual">
                    <b-form-select v-model.trim="form.povo_comunidade" placeholder="" class="mb-3" :options='form_options.options_povo_comunidade' disabled>
                    </b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row v-if="form.povo_comunidade === 'OU'">
                <b-col cols="12">
                  <b-form-group label="20.1. Qual outro?">
                    <b-input-group class="mb-3">
                      <b-form-input type="text"
                                    class="form-control"
                                    placeholder="Infore o outro povo ou comunidade tradicional"
                                    v-model="form.povo_comunidade_outro"
                                    disabled
                                    />
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col cols="12">
                  <b-form-group label="21. Você é representante de pessoas do campo, pertencentes às famílias assentadas pela reforma agrária e/ou famílias de agricultores?">
                    <b-form-select v-model.trim="form.representa_campo" class="mb-3" :options='options_sim_nao' disabled>
                    </b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col cols="12">
                  <b-form-group label="22. Você é representante de famílias acampadas em áreas rurais ou urbanas?">
                    <b-form-select v-model.trim="form.representa_acampamento" placeholder="" class="mb-3" :options='options_sim_nao' disabled>
                    </b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col cols="12">
                  <b-form-group label="23. Você é representante de migrantes, refugiados e apátridas?">
                    <b-form-select v-model.trim="form.representa_imigrante" class="mb-3" :options='options_sim_nao' disabled>
                    </b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col cols="12">
                  <b-form-group label="24. Indique se você se encontra em uma ou mais dessas situações">
                     <multiselect
                            v-model="form.situacoes_participante"
                            :options="form_options.options_situacao"
                            label="text"
                            track-by="value"
                            placeholder="Selecione"
                            selectLabel="" deselectLabel="" selectedLabel=""
                            :tagglabe="true"
                            :multiple="true"
                            disabled>
                        <span slot="maxElements"></span>
                        <span slot="noResult">Nenhum encontrado</span>
                        <span slot="noOptions">Lista vazia</span>
                      </multiselect>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col cols="12">
                  <b-form-group label="25. Faixa etária">
                    <b-form-select v-model.trim="form.faixa_etaria" class="mb-3" :options='form_options.options_faixa_etaria' disabled>
                    </b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col cols="12">
                  <b-form-group label="26. Grau de instrução">
                    <b-form-select v-model.trim="form.grau_instrucao" class="mb-3" :options='form_options.options_grau_instrucao' disabled>
                    </b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row v-if="form.grau_instrucao === 'OU'">
                <b-col cols="12">
                  <b-form-group label="26.1 Qual outro?">
                    <b-input-group class="mb-3">
                      <b-form-input type="text"
                                    class="form-control"
                                    placeholder="Infore o outro grau de instrução"
                                    v-model="form.grau_instrucao_outro"
                                    disabled
                                    />
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col cols="12">
                  <b-form-group label="27. Você possui alguma deficiência física ou intelectual?">
                    <b-form-select v-model.trim="form.deficiencia" class="mb-3" :options='options_sim_nao' disabled>
                    </b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row v-if="form.deficiencia === true">
                <b-col cols="12">
                  <b-form-group label="27.1. Pode nos informar qual? Mas caso você tenha deficiências múltiplas, favor sinalizar mais de uma opção.">
                     <multiselect
                            v-model="form.deficiencias"
                            :options="form_options.options_deficiencias"
                            label="text"
                            track-by="value"
                            placeholder="Selecione"
                            selectLabel="" deselectLabel="" selectedLabel=""
                            :tagglabe="true"
                            :multiple="true"
                            disabled>
                        <span slot="maxElements"></span>
                        <span slot="noResult">Nenhum encontrado</span>
                        <span slot="noOptions">Lista vazia</span>
                      </multiselect>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row v-if="form.deficiencia === true">
                <b-col cols="12">
                  <b-form-group label="27.2. Quanto a serviços e estruturas acessíveis na Conferência, você precisará? Marque somente o estritamente necessário.">
                     <multiselect
                            v-model="form.servicos_acessiveis"
                            :options="form_options.options_servicos_acessiveis"
                            label="text"
                            track-by="value"
                            placeholder="Selecione"
                            selectLabel="" deselectLabel="" selectedLabel=""
                            :tagglabe="true"
                            :multiple="true"
                            disabled>
                        <span slot="maxElements"></span>
                        <span slot="noResult">Nenhum encontrado</span>
                        <span slot="noOptions">Lista vazia</span>
                      </multiselect>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col cols="12">
                  <b-form-group label="28. Onde você usa a Internet?">
                    <multiselect
                            v-model="form.local_uso"
                            :options="form_options.options_local_acesso"
                            label="text"
                            track-by="value"
                            placeholder="Selecione"
                            selectLabel="" deselectLabel="" selectedLabel=""
                            :tagglabe="true"
                            :multiple="true"
                            disabled>
                        <span slot="maxElements"></span>
                        <span slot="noResult">Nenhum encontrado</span>
                        <span slot="noOptions">Lista vazia</span>
                      </multiselect>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row v-if="form.local_uso_outro">
                <b-col cols="12">
                  <b-form-group label="28.1. Possuí outro local de uso?">
                    <b-input-group class="mb-3">
                      <b-form-input type="text"
                                    class="form-control"
                                    placeholder="Infore o outro local de uso."
                                    v-model="form.local_uso_outro"
                                    disabled
                                    />
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col cols="12">
                  <b-form-group label="29. Para acesso a Internet você geralmente utiliza">
                    <b-form-select v-model.trim="form.equipamento_uso" class="mb-3" :options='form_options.options_equipamento_acesso' disabled>
                    </b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col cols="12">
                  <b-form-group label="30. E sua Internet é?">
                    <b-form-select v-model.trim="form.tipo_internet" class="mb-3" :options='form_options.options_tipo_internet' disabled>
                    </b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col cols="12">
                  <b-form-group label="31. Você consegue ver vídeos, lives e interagir através de sua Internet de modo">
                    <b-form-select v-model.trim="form.qualidade_internet" class="mb-3" :options='form_options.options_qualidade_internet' disabled>
                    </b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row v-if="form.faixa_etaria === '01'">
                <b-col cols="12">
                  <b-form-group label="32. Se você é criança ou adolescente participante do evento, por favor deixe aqui os dados de seu responsável">
                    <b-row>
                      <b-col cols="12">
                        <b-form-input type="text"
                                    class="form-control"
                                    placeholder="Nome do responsável"
                                    v-model="form.nome_responsavel"
                                    disabled
                                    />
                      </b-col>
                      <br><br>
                      <b-col cols="12">
                        <b-form-input type="text"
                                class="form-control"
                                placeholder="CPF do responsável"
                                v-model="form.cpf_responsavel"
                                disabled
                                />
                      </b-col>
                      <br><br>
                      <b-col cols="12">
                          <b-form-input type="text"
                                class="form-control"
                                placeholder="E-mail do responsável"
                                v-model="form.email_responsavel"
                                disabled
                                />
                      </b-col>
                      <br><br>
                      <b-col cols="4">
                        <b-form-input v-mask='"###"'
                                type="text"
                                class="form-control"
                                placeholder="DDD do Telefone do responsável"
                                v-model="form.telefone_responsavel_ddd"
                                disabled
                                />
                      </b-col>
                      <b-col cols="8">
                        <b-form-input v-mask='"#####-####"'
                                type="text"
                                class="form-control"
                                placeholder="Número do telefone do responsável"
                                v-model="form.telefone_responsavel_numero"
                                disabled
                                />
                      </b-col>
                    </b-row>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-card>
          </b-form>
        </b-card-body>
      </b-card>
    </b-col>
  </auth-template>
</template>

<script>
import Vue from 'vue'
import AuthTemplate from '@/templates/auth/AuthTemplate'
import VueSelect from 'vue-select'
import Multiselect from 'vue-multiselect'
import miniToastr from 'mini-toastr'

Vue.component('multiselect', Multiselect)

miniToastr.init()

export default {
  name: 'CadastroParticipante',
  components: {
    AuthTemplate,
    VueSelect,
    Multiselect
  },
  created () {
    this.loadForm()
    this.loadParticipante(this.$route.params.token)
  },
  data () {
    return {
      loading: false,
      exibeCpf: true,
      exibeDeficiencia: false,
      form: {
        nome: '',
        nome_social: '',
        email: '',
        confirmaEmail: '',
        termos: false,
        receber_copia: false,
        participacao: null,
        chefe_delegacao: null,
        perfil_representacao: null,
        natureza_representacao: null,
        orgao_representacao: null,
        segmento_representacao: null,
        orgao_instituicao_vinculado: null,
        estado_orgao_instituicao: null,
        cidade_orgao_instituicao: null,
        telefone_orgao_instituicao: null,
        nacionalidade: null,
        eixo_tematico: null,
        cpf: null,
        passaporte: null,
        rg: null,
        orgao_emissor: null,
        data_nascimento: null,
        estado_origem: null,
        cidade_origem: null,
        estado_moradia: null,
        cidade_moradia: null,
        telefone_celular_ddd: null,
        telefone_celular_numero: null,
        email_contato: null,
        genero: null,
        orientacao_sexual: null,
        identidade_genero: null,
        raca_etnia: null,
        povo_comunidade: null,
        povo_comunidade_outro: null,
        representa_campo: null,
        representa_acampamento: null,
        representa_imigrante: null,
        situacoes_participante: [],
        faixa_etaria: null,
        grau_instrucao: null,
        grau_instrucao_outro: null,
        deficiencia: null,
        deficiencias: null,
        servicos_acessiveis: null,
        servico_acessivel_outro: null,
        local_uso: null,
        local_uso_outro: null,
        equipamento_uso: null,
        tipo_internet: null,
        qualidade_internet: null,
        nome_responsavel: null,
        cpf_responsavel: null,
        email_responsavel: null,
        telefone_responsavel_ddd: null,
        telefone_responsavel_numero: null
      },
      form_options: {
        options_participacao: [],
        options_tipo_delegado: [],
        options_perfil_representacao: [],
        options_natureza_representacao: [],
        options_segmento_representacao: [],
        options_eixo_tematico: [],
        options_nacionalidade: [],
        options_genero: [],
        options_orientacao_sexual: [],
        options_identidade_genero: [],
        options_raca_etnia: [],
        options_povo_comunidade: [],
        options_situacao: [],
        options_faixa_etaria: [],
        options_grau_instrucao: [],
        options_deficiencias: [],
        options_servicos_acessiveis: [],
        options_local_acesso: [],
        options_equipamento_acesso: [],
        options_tipo_internet: [],
        options_qualidade_internet: []
      },
      options_sim_nao: [
        {'value': true, 'text': 'Sim'},
        {'value': false, 'text': 'Não'}
      ],
      estados: [],
      cidades_orgao_instituicao: [],
      cidades_origem: [],
      cidades_moradia: [],
      disabled_cidades: true,
      disable_buttons: false,
      valueAceiteCadastro: null,
      salvarForm: false,
      options: [
        {value: true}
      ]
    }
  },
  computed: {
    participacoes () {
      return [
        {'id': 1, 'nome': 'xxx'},
        {'id': 2, 'nome': 'xxx'}
      ]
    },
    exibirOutroLocal () {
      let local = this.form.local_uso
      let valid = false

      for (let i in local) {
        if (local[i].value === 'O') {
          valid = true
        }
      }

      return valid
    },
    isValid () {
      return !this.form.$anyError
    }
  },
  watch: {
    'form.estado_orgao_instituicao': function () {
      if (this.form.estado_orgao_instituicao.length > 0) {
        Vue.http.get('api/cidade/buscarCidades/' + this.form.estado_orgao_instituicao[0].id).then(response => {
          this.cidades_orgao_instituicao = response.data.data.cidades
        })
      } else if (this.form.estado_orgao_instituicao.length === 0) {
        this.form.cidade_orgao_instituicao = null
      }
    },
    'form.estado_origem': function () {
      if (this.form.estado_origem.length > 0) {
        Vue.http.get('api/cidade/buscarCidades/' + this.form.estado_origem[0].id).then(response => {
          this.cidades_origem = response.data.data.cidades
        })
      } else if (this.form.estado_origem.length === 0) {
        this.form.cidade_origem = null
      }
    },
    'form.estado_moradia': function () {
      if (this.form.estado_moradia.length > 0) {
        Vue.http.get('api/cidade/buscarCidades/' + this.form.estado_moradia[0].id).then(response => {
          this.cidades_moradia = response.data.data.cidades
        })
      } else if (this.form.estado_moradia.length === 0) {
        this.form.cidade_moradia = null
      }
    },
    'form.possui_deficiencia': function () {
      let possuiDeficiencia = this.form.possui_deficiencia
      if (possuiDeficiencia === '1') {
        this.exibeDeficiencia = true
      } else {
        this.exibeDeficiencia = false
      }
    }
  },
  methods: {
    loadForm () {
      // Carrega o template com as options das combos
      Vue.http.get('api/participante/atributo/template').then(response => {
        this.form_options = response.data.data
      }).catch(e => {
        console.log('Servidor está fora! ' + e)
      })

      // Carrega os estados
      Vue.http.get('api/estado/buscarEstadosPorRegiao').then(response => {
        this.estados = response.data.data.estados
        console.log(this.estados)
      })
    },
    loadParticipante (token) {
      Vue.http.get('api/participante/token/' + token).then(response => {
        let data = response.body.data
        console.log(data)
        this.form.nome = data.nome
        this.form.nome_social = data.nome_social
        this.form.email = data.email
        this.form.termos = data.termos
        this.form.receber_copia = data.receber_copia
        this.form.participacao = data.participacao
        this.form.tipo_delegado = data.tipo_delegado
        this.form.chefe_delegacao = data.chefe_delegacao
        this.form.perfil_representacao = data.perfil_representacao
        this.form.natureza_representacao = data.natureza_representacao
        this.form.orgao_representacao = data.orgao_representacao
        this.form.segmento_representacao = data.segmento_representacao
        this.form.orgao_instituicao_vinculado = data.orgao_instituicao_vinculado
        this.form.telefone_orgao_instituicao = data.telefone_orgao_instituicao
        this.form.nacionalidade = data.nacionalidade
        this.form.eixo_tematico = data.eixo_tematico
        this.form.cpf = data.cpf
        this.form.passaporte = data.passaporte
        this.form.rg = data.rg
        this.form.orgao_emissor = data.orgao_emissor
        this.form.data_nascimento = data.data_nascimento
        this.form.telefone_celular_ddd = data.telefone_celular_ddd
        this.form.telefone_celular_numero = data.telefone_celular_numero
        this.form.email_contato = data.email_contato
        this.form.genero = data.genero
        this.form.orientacao_sexual = data.orientacao_sexual
        this.form.identidade_genero = data.identidade_genero
        this.form.raca_etnia = data.raca_etnia
        this.form.povo_comunidade = data.povo_comunidade
        this.form.povo_comunidade_outro = data.povo_comunidade_outro
        this.form.representa_campo = data.representa_campo
        this.form.representa_acampamento = data.representa_acampamento
        this.form.representa_imigrante = data.representa_imigrante
        this.form.faixa_etaria = data.faixa_etaria
        this.form.grau_instrucao = data.grau_instrucao
        this.form.grau_instrucao_outro = data.grau_instrucao_outro
        this.form.deficiencia = data.deficiencia
        this.form.servico_acessivel_outro = data.servico_acessivel_outro
        this.form.local_uso = data.local_uso
        this.form.local_uso_outro = data.local_uso_outro
        this.form.equipamento_uso = data.equipamento_uso
        this.form.tipo_internet = data.tipo_internet
        this.form.qualidade_internet = data.qualidade_internet
        this.form.nome_responsavel = data.nome_responsavel
        this.form.email_responsavel = data.email_responsavel
        this.form.telefone_responsavel_ddd = data.telefone_responsavel_ddd
        this.form.telefone_responsavel_numero = data.telefone_responsavel_numero
        this.form.cpf_responsavel = data.cpf_responsavel

        if (data.cidade_origem) {
          this.form.estado_origem = [{
            'id': data.cidade_origem.estado.id,
            'sigla': data.cidade_origem.estado.sigla
          }]

          this.form.cidade_origem = [{
            'id': data.cidade_origem.id,
            'cidade': data.cidade_origem.cidade
          }]
        }

        if (data.cidade_moradia) {
          this.form.estado_moradia = [{
            'id': data.cidade_moradia.estado.id,
            'sigla': data.cidade_moradia.estado.sigla
          }]

          this.form.cidade_moradia = [{
            'id': data.cidade_moradia.id,
            'cidade': data.cidade_moradia.cidade
          }]
        }

        if (data.cidade_orgao_instituicao) {
          this.form.estado_orgao_instituicao = [{
            'id': data.cidade_orgao_instituicao.estado.id,
            'sigla': data.cidade_orgao_instituicao.estado.sigla
          }]

          this.form.cidade_orgao_instituicao = [{
            'id': data.cidade_orgao_instituicao.id,
            'cidade': data.cidade_orgao_instituicao.cidade
          }]
        }

        this.form.deficiencias = []
        for (let i in data.deficiencias) {
          for (let x in this.form_options.options_deficiencias) {
            if (this.form_options.options_deficiencias[x].value === data.deficiencias[i].deficiencia) {
              this.form.deficiencias.push({
                'value': data.deficiencias[i].deficiencia,
                'text': this.form_options.options_deficiencias[x].text
              })
            }
          }
        }

        this.form.situacoes_participante = []
        console.log(this.form_options.options_situacao)
        for (let i in data.situacoes) {
          for (let x in this.form_options.options_situacao) {
            if (this.form_options.options_situacao[x].value === data.situacoes[i].situacao) {
              this.form.situacoes_participante.push({
                'value': data.situacoes[i].situacao,
                'text': this.form_options.options_situacao[x].text
              })
            }
          }
        }

        this.form.servicos_acessiveis = []
        for (let i in data.servicos_acessiveis) {
          for (let x in this.form_options.options_servicos_acessiveis) {
            if (this.form_options.options_servicos_acessiveis[x].value === data.servicos_acessiveis[i].servico) {
              this.form.servicos_acessiveis.push({
                'value': data.servicos_acessiveis[i].servico,
                'text': this.form_options.options_servicos_acessiveis[x].text
              })
            }
          }
        }

        this.form.local_uso = []
        for (let i in data.local_uso) {
          for (let x in this.form_options.options_local_acesso) {
            if (this.form_options.options_local_acesso[x].value === data.local_uso[i].local_uso) {
              this.form.local_uso.push({
                'value': data.local_uso[i].servico,
                'text': this.form_options.options_local_acesso[x].text
              })
            }
          }
        }
      })
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
  h1 {
    text-align: center
  }

  .text-muted  {
    color: #000 !important;
  }

  legend {
    font-weight: bold !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/auth/InscricaoPreview.vue